export class EmployeeCostCenterAdd {
    costCenterIds: number[];
    employeeId: number;
}
